import moment from 'TPCore/moment';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';

window.addEventListener('load', function load(){
  moment.tz.setDefault(
    document.documentElement.dataset['tz'] || moment.tz.guess() || 'Asia/Hong_Kong'
  );
});
window.moment = moment;
